export default {
  switchActiveLanguage: 'Español',
  stopAudio: 'Stop Audio',
  playAudio: 'Play Audio',
};
